import { render, staticRenderFns } from "./form-error.vue?vue&type=template&id=33377960&scoped=true&"
import script from "./form-error.vue?vue&type=script&lang=js&"
export * from "./form-error.vue?vue&type=script&lang=js&"
import style0 from "./form-error.vue?vue&type=style&index=0&id=33377960&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33377960",
  null
  
)

export default component.exports